import { render, staticRenderFns } from "./PppiStatsHome.vue?vue&type=template&id=3ff55687&scoped=true"
import script from "./PppiStatsHome.vue?vue&type=script&lang=js"
export * from "./PppiStatsHome.vue?vue&type=script&lang=js"
import style0 from "./PppiStatsHome.vue?vue&type=style&index=0&id=3ff55687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff55687",
  null
  
)

export default component.exports